export default {"src":"/_next/static/media/arbitrum.8ddb1b22.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};